<template>
    <div id="pcm-attendance-report-view">
        <div class="container-fluid">
            <!-- Page Heading -->
            <div class="d-sm-flex align-items-center justify-content-between mb-4">
                <h1 class="h3 mb-0 text-gray-800">Báo cáo Chấm công (đang phát triển)</h1>
            </div>
            <!-- Content Row -->
            <div class="row">
                <div class="col-xl-12">
                    <div class="card mb-4 border-left-primary" v-loading="loadingState.filter">
                        <div class="card-body">
                            <h6>Điều kiện lọc</h6>
                            <div class="row">
                                <div class="col-md-2 form-group">
                                    <el-date-picker
                                        v-model="form.filter.date"
                                        class="w-100"
                                        type="month"
                                        placeholder="Chọn tháng"
                                        format="MM/yyyy"
                                        value-format="yyyy-MM"
                                        :clearable="false"
                                        @change="loadData()"
                                        :picker-options="pickerOptions"
                                        >
                                    </el-date-picker>
                                </div>
                                <div class="col-md-10 form-group">
                                    <el-select v-model="form.filter.users" placeholder="Nhân sự" multiple filterable @change="loadData()">
                                        <el-option v-for="user in form.option.users" :key="user.id" :label="user.full_name" :value="user.id">
                                            <div class="d-flex align-items-center">
                                                <div class="pr-2">
                                                    <avatar :username="user.first_name + ' ' + user.last_name" :size="30"></avatar>
                                                </div>
                                                <div class="w-100">
                                                    <span class="font-weight-bold">
                                                        {{user.full_name}} 
                                                    </span>
                                                    <span class="float-right">{{user.email}}</span>
                                                </div>
                                            </div>
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-12">
                    <div class="card shadow mb-4" v-loading="loadingState.list">
                        <!-- Card Header - Dropdown -->
                        <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                            <h6 class="m-0 font-weight-bold text-primary">Danh sách nhân sự</h6>
                        </div>
                        <!-- Card Body -->
                        <div class="card-body text-center">
                            <el-table :data="attendances" style="width: 100%">
                                <el-table-column label="Tên">
                                    <template slot-scope="scope">
                                        <div class="d-flex">
                                            <div class="pr-2">
                                                <avatar :username="scope.row.first_name + ' ' + scope.row.last_name" :size="45"></avatar>
                                            </div>
                                            <div class="user-item-name">
                                                <span class="font-weight-bold">
                                                    {{scope.row.full_name}}
                                                </span>
                                                <br>
                                                <span>{{ scope.row.email }}</span>
                                            </div>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="total_late" label="Lần đi muộn" />
                                <el-table-column label="Ngày làm thực tế">
                                    <template slot-scope="scope">
                                        <span>{{ parseFloat(scope.row.total_working) || 0 }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="#" fixed="right" width="100">
                                    <template slot-scope="scope">
                                        <el-button size="mini" @click="openDetail(scope.row)">Chi tiết</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog title="Chi tiết chấm công"
            custom-class="el-dialog-body-gray" 
            :visible.sync="dialogVisible.detail"
            top="5vh"
        >
            <h4>{{detail.user}}</h4>
            <el-table :data="detail.list" style="width: 100%" v-loading="loadingState.detail">
                <el-table-column label="Ngày">
                    <template slot-scope="scope">
                        <span class="badge badge-heading" 
                            :class="{'badge-success': scope.row.type == 0, 'badge-primary': scope.row.type == -1,' badge-warning': (scope.row.type >= 1 && scope.row.type <= 3), 'badge-danger': scope.row.id == 0}" 
                            style="font-size: 100%">
                            {{scope.row.check_date | formatDate('ddd, DD/MM')}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="Giờ vào">
                    <template slot-scope="scope">
                        <span class="font-weight-bold" :class="{'text-danger': scope.row.type == 1 || scope.row.type == 3}">{{ scope.row.check_in | formatDate('HH:mm') }}</span>
                        <br>
                        <span class="small">{{scope.row.reason_late}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="Giờ ra">
                    <template slot-scope="scope">
                        <span class="font-weight-bold" :class="{'text-danger': scope.row.type == 2 || scope.row.type == 3}">{{ scope.row.check_out | formatCheckOut(scope.row.check_date) }}</span>
                        <br>
                        <span class="small">{{scope.row.reason_soon}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="Công số">
                    <template slot-scope="scope">
                        <span class="font-weight-bold">{{ parseFloat(scope.row.work_rate) || 0 }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="#">
                    <template slot-scope="scope">
                        <i v-if="scope.row.id > 0 && scope.row.type == 0 && scope.row.status == 1" class="fas fa-check-circle fa-lg fa-fw text-success"></i>
                        <i v-if="scope.row.id > 0 && scope.row.type > 0 && scope.row.status == 1" class="fas fa-check-circle fa-lg fa-fw text-warning"></i>
                        <i v-if="scope.row.id > 0 && scope.row.status == 0" class="far fa-hourglass fa-lg fa-fw"></i>
                        <span v-if="scope.row.id == 0 || scope.row.type == -1">--</span>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>

    </div>
</template>

<script>
import Avatar from 'vue-avatar'
import API_USER from '@/utils/api/user'
import API_ATTENDANCE from '@/utils/api/attendance'
import UserModel from '@/model/user'
import moment from 'moment'

export default {
    name: 'pcm-attendance-report-view',
    components: {
        Avatar
    },
    data() {
        return {
            loadingState: {
                filter: false,
                list: false,
                detail: false
            },
            dialogVisible: {
                detail: false
            },
            pickerOptions: {
                disabledDate(time) {
                return time.getTime() > Date.now();
                }
            },
            UserModel: UserModel
            ,
            form: {
                filter: {
                    users: [],
                    date: moment().format('YYYY-MM')
                },
                option: {
                    users: []
                }
            },
            attendances: [],
            detail: {
                user: '',
                list: []
            }
        }
    },
    created() {
        let self = this
        this.$emit('activeMenu', 'reports.attendance')

        self.loadOption()
        self.loadData()
    },
    methods: {
        loadOption() {
            let self = this
            self.loadingState.filter = true
            API_USER.getOption(self.$axios, {}, function(data){
                self.loadingState.filter = false
                if (data.status) {
                    self.form.option.users = data.data
                }
            }, function(error){})
        },
        loadData() {
            let self = this
            self.loadingState.list = true
            API_ATTENDANCE.getReport(self.$axios, self.form.filter, function(data){
                self.loadingState.list = false
                if (data.status) {
                    self.attendances = data.data
                }
            }, function(error){})
        },
        openDetail(row) {
            let self = this
            self.dialogVisible.detail = true
            self.detail.user = row.full_name
            self.loadingState.detail = true
            self.detail.list = []
            let query = {
                date: self.form.filter.date,
                user_id: row.id
            }
            API_ATTENDANCE.getList(self.$axios, query, (data) => {
                self.loadingState.detail = false
                if (data.status) {
                    self.detail.list = data.data
                }
            }, (error) => {
                self.loadingState.detail = false
            })
        }
    }
}
</script>

